import React from 'react';
import PropTypes from 'prop-types';
import { Message } from 'semantic-ui-react';
import { diffDate, convertDateFormat } from '../../../../../scripts/moment';
import {
  FREETIME,
  EAT,
  RECREATION,
  CHECKIN,
} from '../../../constants/activityTypes';

const MessageOverlap = props => {
  let { dateDay, dateActivity, movementName } = props;
  const isOverload =
    diffDate(
      convertDateFormat(dateDay, 'YYYY-MM-DD'),
      convertDateFormat(dateActivity, 'YYYY-MM-DD'),
      'days'
    ) !== 0;
  return isOverload &&
    [FREETIME, EAT, RECREATION].indexOf(movementName) !== -1 ? (
    <Message error>
      Warning!! This activity is started on the next day. please arrange your
      activities or delete this activity and add on the next day.
    </Message>
  ) : isOverload && movementName === CHECKIN ? (
    <Message error>
      Warning!! Check in is started on the next day. please arrange your Check
      in on the next day.
    </Message>
  ) : null;
};
MessageOverlap.propTypes = {
  dateDay: PropTypes.string,
  dateActivity: PropTypes.string,
  movementName: PropTypes.string,
};

export default MessageOverlap;
